import React from 'react';
import Menu from './Menu';
import { MenuItem } from './MenuItem';

interface TerminalMenuProps {
  items: MenuItem[];
}

const TerminalMenu: React.FC<TerminalMenuProps> = ({ items }) => {
  return <Menu items={items} />;
};

export default TerminalMenu;

 